<nav
  [style]="menuStyles"
  [ngStyle]="{
    'position': isHome() ? 'absolute' : 'fixed',
    '--header-background-color': this.isHome() ? 'transparent' : menuStyles['--header-background-color']
    }"
  class="navbar navbar-expand-lg navbar-light bg-light d-flex justify-content-between flex-nowrap"
  [ngClass]="{'pt-4': !isLoggedIn()}"
>
  <div class="container main-container">
    @if (logoStyles) {
      <div class="d-flex align-content-center">
        <app-logo-text
          role="button"
          (click)="navigationLogo()"
          [inputStyle]="logoStyles">
        </app-logo-text>

        <div class="social-links ms-3 d-none d-md-flex align-items-center">
          <a *ngFor="let network of clubSocialNetwork" mat-icon-button [href]="network.href" target="_blank">
            <i [class]="network.class"></i>
          </a>
        </div>
      </div>
    }

    <!--  Visão desktop: Mostra do md pra cima -->
    <div class="d-none d-md-block nav-items align-content-center custom-scrollbar" style="min-width: fit-content;">
      <nav class="menu d-flex align-items-center" [ngStyle]="menuStyles">
        @for (menuItem of menuItems(); track $index; let isLast = $last) {
          <div class="nav-item d-grid px-3 pt-1 cursor-pointer text-center text-nowrap"
            (click)="navigationHeaderItems(menuItem.id)">
            <span class="align-content-end">
              {{ menuItem.name | replaceText }}
            </span>
          </div>
          @if (!isLast) {
            <div class="vertical-line"></div>
          }
        }
      </nav>
    </div>

    <!-- Sidebar: Visão mobile: Escondido do md pra cima -->
    @if (logoStyles && !isBlocked) {
    <div class="d-flex d-md-none">
      @if (isLoggedIn()) {
        <notification-dropdown
          class="pe-3"
          [styles]="menuStyles"
          [notifications]="notifications"
          (markAllNotificationsAsRead)="markAllNotificationsAsRead()">
        </notification-dropdown>
      }
      <app-user-side-bar
        [menuItems]="headerItems()"
        [activeSections]="activeSections"
        [userInfo]="userInfo"
        [isDependent]="isDependent()"
        [isLoggedIn]="isLoggedIn()"
        [selectedMenuItem]="selectedMenuItem"
        [inputStyles]="menuStyles"
        [userBlocked]="userBlocked"
        [logoStyles]="logoStyles"
        [buttonStyles]="importantStyles"
        (selectedMenuItemChange)="navigationHeaderItems($event)">
      </app-user-side-bar>
    </div>
    }

    <!--  Visão desktop: Mostra do md pra cima -->
    @if (!isLoggedIn() && !isDependent()) {
    <div class="d-none d-md-flex align-content-center" style="min-width: fit-content;">
      <div class="d-flex flex-wrap align-content-center justify-content-center">
        <app-button
          class="mx-2 my-1 hover-button"
          id="cadastro-socio"
          [buttonOptions]="buttonGonnaBePartnerOptions"
          routerLink="/cadastro-socio">
        </app-button>

        <app-button
          class="mx-2 my-1 hover-button-enter"
          id="header-login"
          [buttonOptions]="buttonLoginOptions"
          routerLink="/login">
        </app-button>
      </div>
    </div>
    } @else {
      <div class="d-flex d-none d-md-flex" style="min-width: fit-content;" *ngIf="hasUserInfo || isDependent()">
        <div class="vr"></div>
        <div class="d-flex ms-2 justify-content-end user-area">
          @if(!isDependent()){
            <notification-dropdown [styles]="menuStyles" [notifications]="notifications"
              (markAllNotificationsAsRead)="markAllNotificationsAsRead()">
            </notification-dropdown>
          }
          <user-dropdown
            [styles]="menuStyles"
            [userInfo]="userInfo"
            [isDependent]="isDependent()"
            [userBlocked]="userBlocked">
          </user-dropdown>
        </div>
      </div>
    }
  </div>
</nav>
